module.exports = __webpack_public_path__ + "img/acredo_logo_mobile.2f380d4.svg";